export default __webpack_public_path__ + "static/media/icon-identification-uploader.a87065bb.svg";